// extracted by mini-css-extract-plugin
export var formContainer = "_db-0";
export var message = "_db-1";